import { parseIntent, sanitiseReturnTo, sanitiseSource } from "./intent";

const PENDING_VERIFICATION_CONTEXT_KEY = "pendingVerificationContext";

function sanitiseString(value) {
    if (value === null || value === undefined) {
        return null;
    }

    const trimmed = String(value).trim();
    return trimmed || null;
}

function sanitiseChannel(value) {
    const channel = sanitiseString(value)?.toLowerCase() || null;
    return channel === "sms" || channel === "email" ? channel : null;
}

function sanitiseMethodSelection(methodSelection = null) {
    if (!methodSelection || typeof methodSelection !== "object") {
        return null;
    }

    return {
        sms: methodSelection.sms
            ? {
                available: methodSelection.sms.available === true,
                destinationHint: sanitiseString(methodSelection.sms.destinationHint),
            }
            : null,
        email: methodSelection.email
            ? {
                available: methodSelection.email.available === true,
                destinationHint: sanitiseString(methodSelection.email.destinationHint),
            }
            : null,
    };
}

function sanitiseOtpLength(value) {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= 4 && parsed <= 6 ? parsed : null;
}

function sanitiseOtpPreview(value) {
    const digits = sanitiseString(value)?.replace(/\D/g, "") || null;
    return digits && digits.length >= 4 && digits.length <= 6 ? digits : null;
}

function buildPersistedContext(context = {}) {
    const challengeId = sanitiseString(context.challengeId);

    if (!challengeId) {
        return null;
    }

    return {
        challengeId,
        requestId: sanitiseString(context.requestId),
        channel: sanitiseChannel(context.channel),
        phone: sanitiseString(context.phone),
        email: sanitiseString(context.email)?.toLowerCase() || null,
        emailDestinationHint: sanitiseString(context.emailDestinationHint),
        intent: parseIntent(context.intent),
        source: sanitiseSource(context.source),
        returnTo: sanitiseReturnTo(context.returnTo),
        brokerageId: sanitiseString(context.brokerageId),
        hasExplicitIntent: context.hasExplicitIntent === true,
        rememberDevice: context.rememberDevice === true,
        fallbackReason: sanitiseString(context.fallbackReason),
        otpLength: sanitiseOtpLength(context.otpLength),
        otpPreview: sanitiseOtpPreview(context.otpPreview),
        testUserBypass: context.testUserBypass === true,
        methodSelection: sanitiseMethodSelection(context.methodSelection),
    };
}

export function persistPendingVerificationContext(context = {}) {
    if (typeof window === "undefined") {
        return null;
    }

    const nextContext = buildPersistedContext(context);
    if (!nextContext) {
        clearPendingVerificationContext();
        return null;
    }

    window.sessionStorage.setItem(PENDING_VERIFICATION_CONTEXT_KEY, JSON.stringify(nextContext));
    return nextContext;
}

export function readPendingVerificationContext() {
    if (typeof window === "undefined") {
        return null;
    }

    try {
        const parsed = JSON.parse(window.sessionStorage.getItem(PENDING_VERIFICATION_CONTEXT_KEY) || "null");
        return buildPersistedContext(parsed);
    } catch (_error) {
        return null;
    }
}

export function clearPendingVerificationContext() {
    if (typeof window === "undefined") {
        return;
    }

    window.sessionStorage.removeItem(PENDING_VERIFICATION_CONTEXT_KEY);
}
